import axios from 'axios'
import cookieService from '@/services/cookieService'
import config from '@/config'

let abortController = new AbortController()
let isHandlingExpiredToken = false

const apiClient = axios.create({
  baseURL: config.serverSSOUrl,
  timeout: 30000
})

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    const currentTime = Math.floor(Date.now() / 1000)
    return payload.exp < currentTime
  } catch (e) {
    return true
  }
}

const handleExpiredToken = () => {
  if (!isHandlingExpiredToken) {
    isHandlingExpiredToken = true
    abortController.abort()
    abortController = new AbortController()
    localStorage.setItem('isAuthenticated', false)
  }
}

apiClient.interceptors.request.use((config) => {
  const token = cookieService.getCookie('user_token')
  if (token) {
    if (isTokenExpired(token)) {
      handleExpiredToken()
    } else {
      config.headers.Authorization = token
    }
  }
  config.signal = abortController.signal
  return config
})

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      isHandlingExpiredToken = false
      handleExpiredToken()
    }
    return Promise.reject(error)
  }
)

const apiSsoService = {
  get: (url, params = {}) => apiClient.get(url, { params }),
  post: (url, data, config = {}) => apiClient.post(url, data, config),
  put: (url, data, config = {}) => apiClient.put(url, data, config),
  patch: (url, data, config = {}) => apiClient.patch(url, data, config),
  delete: (url, params = {}, config = {}) =>
    apiClient.delete(url, { params }, config)
}

export default apiSsoService
